<template>
  <div>
    <QrcodeStream :camera="camera" @decode="onDecode" @init="onInit" />
    <p class="error--text">{{ error }}</p>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  name: "QrReader",
  components: {
    QrcodeStream
  },
  props: {
    value: { type: String, default: null }
  },
  data() {
    return {
      error: "",
      camera: "front"
    };
  },
  watch: {
    error: function(v) {
      this.$emit("error", v);
    }
  },
  methods: {
    onDecode(result) {
      console.log("reached decode");
      this.$emit("decode", result);
    },
    onInit(promise) {
      const setErrorMessage = function(msg) {
        this.error = msg;
      }.bind(this);
      console.log("promise", promise);
      try {
        console.log("enter into try promise");
        promise.then(
          function(value) {
            /* code if successful */
            if (value) {
              console.log("success value", value);
              if (value.capabilities) {
                if (!value.capabilities.deviceId) {
                  console.log(
                    "MediaStreamTrackの機能が定義されていますが、DeviceId がありません。MediaStreamTrack capabillities defined but no deviceId"
                  );
                  setErrorMessage(
                    "MediaStreamTrackの機能が定義されていますが、DeviceId がありません。MediaStreamTrack capabillities defined but no deviceId"
                  );
                } else {
                  console.log("MediaStreamTrack capabillities success");
                }
              } else {
                console.log(
                  "MediaStreamTrackの機能が定義されていません。MediaStreamTrack capabillities not defined"
                );
                setErrorMessage(
                  "MediaStreamTrackの機能が定義されていません。MediaStreamTrack capabillities not defined"
                );
              }
            } else {
              console.log(
                "promiseは成功しましたが、値は返されません。promise success but not return value"
              );
              setErrorMessage(
                "promiseは成功しましたが、値は返されません。promise success but not return value"
              );
            }
          },
          function(error) {
            console.log("error value", error, error.name);
            let msg = "";
            if (error.name === "NotAllowedError") {
              msg =
                "ERROR: カメラへのアクセスが拒否されました。カメラへのアクセス許可を与える必要があります。you need to grant camera access permisson";
            } else if (error.name === "NotFoundError") {
              msg =
                "ERROR: このデバイスにはカメラがありません。no camera on this device";
            } else if (error.name === "NotSupportedError") {
              msg =
                "ERROR: HTTPSでの接続が必要です (セキュアなコンテキストが必要です(HTTPS、ローカルホスト))secure context required (HTTPS, localhost)";
            } else if (error.name === "NotReadableError") {
              msg =
                "ERROR: 既にカメラが使用中です。ERROR: is the camera already in use?";
            } else if (error.name === "OverconstrainedError") {
              msg =
                "ERROR: インストールされているカメラが適切ではありません。installed cameras are not suitable";
            } else if (error.name === "StreamApiNotSupportedError") {
              msg =
                "このブラウザではストリーム API がサポートされていません。Stream API is not supported in this browser";
            } else {
              msg = error.name + "(error name unknown): " + error;
            }
            setErrorMessage(msg);
          }
        );
      } catch (error) {
        console.log("try promise exception", error, error.name);
        setErrorMessage(error.name + "(try promise exception): " + error);
      }
    }
  }
};
</script>
